import React, { useState } from 'react'
import { Table } from '../../../components/shared'
import useSearchAndFilter from '../../../hooks/useSearchAndFilter';
import FilterSideMenu from '../../../components/shared/FilterSideMenu';
import { AddIcon, FilterIcon, FilterIconWhite } from '../../../assets';
import { Badge } from '@mui/material';
import { Loader } from '../../../components/loaders/loaders';
import { columns } from './types/RegionTypes';
import AddEditRegionModal from './components/AddEditRegionModal';
import { DELETE_REGION_ENDPOINT, GET_REGION_LISTING } from '../../../apis/end-points';
import { DEFAULT_PAGE_SIZE } from '../../../utils/constants';
import { SERVICE_CONFIG_MESSAGES } from '../../../utils/message';

const RegionListing = () => {
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isRegionModalOpen, setIsRegionModalOpen] = useState<boolean>(false);
  const [selectedRegion, setSelectedRegion] = useState<any>({});
  const {
    data,
    loading,
    setLoading,
    closeOpenfilterModal,
    isShowFilterModal,
    selectStatus,
    setSelectStatus,
    fetchFilteredData,
    fetchWithCurrentFilters,
    captureAppliedFilters,
    clearCurrentFilters,
    filterApplied,
    setFilterApplied,
    stateOfRegion,
    region,
    setRegion,
    setStateOfRegion,
  }
    = useSearchAndFilter<any>({
      apiUrl: GET_REGION_LISTING,
      limit: DEFAULT_PAGE_SIZE,
      mapUserData: (data: any[]) => data,
      screenKey: "regionListing",
    });

  const handleCloseModal = () => {
    setIsRegionModalOpen(false);
  }
  const handleEdit = (rowData: any) => {
    setIsRegionModalOpen(true);
    setIsEdit(true);
    setSelectedRegion(rowData);
  }

  const handleClickAdd = () => {
    setIsRegionModalOpen(true);
    setIsEdit(false);
  }

  if (loading) {
    return <Loader />;
  } else if (isRegionModalOpen) {
    return <AddEditRegionModal
      isEdit={isEdit}
      isOpen={isRegionModalOpen}
      onClose={handleCloseModal}
      initialData={isEdit ? selectedRegion : null}
      onSuccess={fetchWithCurrentFilters}
    />

  }

  return (
    <div
      className={`tableWrap ${isShowFilterModal ? "tableWrap--filterOpen" : ""
        }`}
    >
      <div className="tableWrap__head tableWrap__head--end">
        <div className="btn__group formRow--flexEnd">
          {/* <button
            className="btn btn__primary"
            onClick={handleClickAdd}
          >
            Add New Region
          </button> */}
          {filterApplied ? (
            <Badge badgeContent=" " color="primary">
              <button
                className={
                  !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                }
                onClick={closeOpenfilterModal}
              >
                {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                Filter
              </button>
            </Badge>
          ) : (
            <button
              className={
                !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
              }
              onClick={() => {
                closeOpenfilterModal();
              }}
            >
              {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
              Filter
            </button>
          )}

          <FilterSideMenu
            isShowFilterModal={isShowFilterModal}
            closeOpenfilterModal={closeOpenfilterModal}
            selectStatus={selectStatus}
            setSelectStatus={setSelectStatus}
            isHubHide={true}
            isOrderTypeHide={true}
            isOrderStatusHide={true}
            isRoleHide={true}
            isServiceHide={true}
            showRegion={true}
            setRegion={setRegion}
            setStateOfRegion={setStateOfRegion}
            region={region}
            stateOfRegion={stateOfRegion}
            showCustomerName={false}
            showAgentName={false}
            isAllCustomerTypeHide={true}
            isAgentTypeHide={true}
            isStatusHide={true}
            fetchFilteredData={fetchFilteredData}
            onFiltersApplied={captureAppliedFilters}
            filterApplied={filterApplied}
            setFilterApplied={setFilterApplied}
            table="RegionListingTable"
            clearFiltersFromStorage={clearCurrentFilters}
          />   
          <button
            className="btn btn__white w_fitContent"
            onClick={handleClickAdd}
          >
            <AddIcon />
            Create New
          </button>
        </div>
      </div>
      <Table
        table='regionList'
        columns={columns}
        setLoading={setLoading}
        data={data}
        getApiData={fetchWithCurrentFilters}
        editIcon={true}
        manageIcon={false}
        onEditNaviagte={{
          apiUrl: "",
          urlID: "id",
          onClick: handleEdit,
          isEditWithoutLink: true,
        }}
        deleteIcon={true}
        onDeleteConfig={{
          apiUrl: `${DELETE_REGION_ENDPOINT}`,
          urlID: "id",
          successMessage: SERVICE_CONFIG_MESSAGES.REGION_DELETE_SUCCESS,
          heading: SERVICE_CONFIG_MESSAGES.REGION_DELETE_HEADING,
          rowName: "region",
          para: SERVICE_CONFIG_MESSAGES.REGION_DELETE_CONFIRM,
          deleteByPutApi: true,
        }}
      />
    </div>
  )
}

export default RegionListing
